import React from "react";
import { Link } from "react-router-dom";

const ThankYou = () => {
  return (
    <main className="brand-service-page" style={{ paddingTop: "140px" }}>
      <div className="card" style={{ textAlign: "center" }}>
        <h2>Thank You</h2>
        <p>Your request has been received. Our team will contact you shortly.</p>
        <Link className="call-btn" to="/">
          Back to Home
        </Link>
      </div>
    </main>
  );
};

export default ThankYou;
